var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'app-page-section-wrapper',
    ("app-page-section-wrapper--bottom-line-" + _vm.bottomLineClass),
    ("app-page-section-wrapper--top-line-" + _vm.topLineClass) ]},[_c(_vm.tag,{tag:"Component",class:['app-page-section', _vm.internalClass],style:(_vm.sectionStyles)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }